<template>
	<div>
		<el-tabs v-model="formInline.type" @tab-click="handleClick">
			<el-tab-pane label="报修评价" name="报修"></el-tab-pane>
			<el-tab-pane label="服务评价" name="服务"></el-tab-pane>
		</el-tabs>
		<el-form :inline="true" :model="formInline">
			<el-form-item label="评价人">
				<el-input v-model="formInline.name"  placeholder="请输入评价人姓名"></el-input>
			</el-form-item>
			<el-form-item label="联系电话">
				<el-input v-model="formInline.phone"  placeholder="请输入评价人联系电话"></el-input>
			</el-form-item>
			<el-form-item label="评价星数">
				<el-select v-model="formInline.stars" placeholder="请选择评价星数">
					<el-option label="1星" value="1"></el-option>
					<el-option label="2星" value="2"></el-option>
					<el-option label="3星" value="3"></el-option>
					<el-option label="4星" value="4"></el-option>
					<el-option label="5星" value="5"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="handleCurrentChange(1)">搜索</el-button>
			</el-form-item>
			<el-form-item>
				<el-button @click="clear()">重置</el-button>
			</el-form-item>
		</el-form>
		<el-table :data="tableData" style="width: 100%;">
			<el-table-column align="center" prop="username" label="评价人"></el-table-column>
			<el-table-column align="center" prop="createTime" label="评价时间">
				<template slot-scope='{row}'>
					{{setTime(row.createTime)}}
				</template>
			</el-table-column>
			<el-table-column align="center" prop="obj.roomNumber" label="房间号"></el-table-column>
			<el-table-column align="center" prop="obj.projectName" label="评价项目"></el-table-column>
			<el-table-column align="center" prop="stars" label="评价星数"></el-table-column>
			<el-table-column align="center" prop="phone" label="联系电话"></el-table-column>
			<el-table-column align="center" label="操作">
				<template slot-scope="{row}">
					<el-button size="small" @click="goDetail(row)">查看</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination v-if="totalNum>0" @size-change="handleSizeChange" @current-change="handleCurrentChange"
			:page-sizes="[10, 20, 30, 50]" :page-size="formInline.pageSize" layout="total, sizes, prev, pager, next, jumper"
			:total="totalNum">
		</el-pagination>
		<el-dialog title="报修详情" width="40%" :visible.sync="dialogVisible" :close-on-click-modal="false" :append-to-body="false">
			<div style="display: flex;justify-content: space-between;border-bottom: 5px solid black;">
				<div class="list">
					<div>报修人:{{list.username}}</div>
					<div>房间号:{{list.roomNumber}}</div>
					<div>报修时间:{{setTime(obj.createTime)}}</div>
					<div>故障类型:公寓报修</div>
				<!-- 	<div>故障区域:{{obj.area}}</div> -->
					<!-- <div v-for="s in obj.area">故障区域:{{s+' '}}</div> -->
					<div>故障描述:{{obj.faultDescribe}}</div>
					
					<div>故障图片:</div>
				<!-- 	<img style="width: 100px;" :src="obj.showPath" alt=""> -->
					<div v-for="s in obj.showPathList" >
						<img  :src="s" alt=""  width="100px">
					</div>
				</div>
				<div class="list">
					<div>上门时间:{{setTime(obj.visitStartTime)}}</div>
					<div>联系电话:{{obj.phone}}</div>
					<div>留言:{{obj.leaveMessage}}</div>
				</div>
			</div>
			<div class="list" style="border-bottom: 5px solid black;">
				<h3>工人服务</h3>
				<div>
					上门服务:
				</div>
				<div>维修结果:{{obj.result}}</div>
				<div>备注:</div>
				<div>图片:</div>
			</div>
			<div class="list">
				<h3>评价记录</h3>
				<div>
					评价时间:{{setTime(list.createTime)}}
				</div>
				<div>评价项目:{{list.type}}</div>
				<div>评价星级:{{list.stars}}</div>
				<div>评价内容:{{list.content}}</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
			</span>
		</el-dialog>
		<el-dialog title="服务详情" width="40%" :visible.sync="dialogVisible2" :close-on-click-modal="false" :append-to-body="false">
			<div style="display: flex;justify-content: space-between;border-bottom: 5px solid black;">
				<div class="list">
					<div>申请人:{{list2.username}}</div>
					<div>房间号:{{list2.roomNumber}}</div>
					<div>服务时间:{{setTime(obj2.createTime)}}</div>
					<div>服务项目:{{obj2.projectName}}</div>
				
				<!-- 	<div>服务描述:{{obj2.faultDescribe}}</div> -->
				<!-- 	<div>服务图片:</div>
					<img style="width: 100px;" :src="obj2.showPath" alt=""> -->
				</div>
				<div class="list">
					<div>上门时间:{{setTime(obj2.visitStartTime)}}</div>
					<div>联系电话:{{obj2.phone}}</div>
					<div>留言:{{obj2.leaveMessage}}</div>
				</div>
			</div>
<!-- 			<div class="list" style="border-bottom: 5px solid black;">
				<h3>工人服务</h3>
				<div>
					上门服务:
				</div>
				<div>维修结果:{{obj.result}}</div>
				<div>备注:</div>
				<div>图片:</div>
			</div> -->
			<div class="list">
				<h3>评价记录</h3>
				<div>
					评价时间:{{setTime(list2.createTime)}}
				</div>
				<div>评价项目:{{list2.type}}</div>
				<div>评价星级:{{list2.stars}}</div>
				<div>评价内容:{{list2.content}}</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible2 = false">取 消</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
export default {
  data() {
    return {
      activeName: "报修评价",
      formInline: {
        name: "",
        phone: "",
        stars: "",
        currentPage: 1,
        pageSize: 10,
        type: "报修",
      },
      oldFormLine: {},
      tableData: [],
      dialogVisible: false,
      list: {},
      obj: {},
      dialogVisible2: false,
      list2: {},
      obj2: {},
      totalNum: 0,
    };
  },
  mounted() {
    this.oldFormLine = JSON.parse(JSON.stringify(this.formInline));
    this.goAll();
  },
  methods: {
    handleCurrentChange(val) {
      this.formInline.currentPage = val;
      this.goAll();
    },
    handleSizeChange(val) {
      this.formInline.pageSize = val;
      this.goAll();
    },
    handleClick(tab, event) {
      this.formInline.currentPage = 1;
      this.goAll();
    },
    goAll() {
      //查询列表接口
      this.$http
        .post("/api/bdEvaluate/queryWebBdEvaluate", {
          ...this.formInline,
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.tableData = res.data.data.items;
            this.totalNum = res.data.data.totalNum;
          } else {
            this.tableData = [];
            this.totalNum = 0;
          }
        })
        .catch((err) => {});
    },
    clear() {
      //重置接口
      this.formInline = JSON.parse(JSON.stringify(this.oldFormLine));
      this.goAll();
    },
    goDetail(val) {
      if (this.formInline.type == "报修") {
        this.dialogVisible = true;
        this.list = JSON.parse(JSON.stringify(val));
        this.obj = this.list.obj;
      } else {
        this.dialogVisible2 = true;
        this.list2 = JSON.parse(JSON.stringify(val));
        this.obj2 = this.list2.obj;
      }
    },
  },
};
</script>
<style scoped="scoped">
.list > div {
  margin-bottom: 5px;
}
</style>
